import { render, staticRenderFns } from "./ReviewBoosterTagItemContent.vue?vue&type=template&id=32704543&scoped=true&"
import script from "./ReviewBoosterTagItemContent.vue?vue&type=script&lang=js&"
export * from "./ReviewBoosterTagItemContent.vue?vue&type=script&lang=js&"
import style0 from "./ReviewBoosterTagItemContent.vue?vue&type=style&index=0&id=32704543&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32704543",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
